export const createLogger = loggerName => {
    const appendPrefixLoggerName = args => {
        if (typeof args[0] === 'string') {
            args[0] = `[${loggerName}] ` + args[0];
        }
    };

    return {
        info: function () {
            if (!isLogEnabled(loggerName)) {
                return;
            }

            const args = Array.prototype.slice.call(arguments);
            appendPrefixLoggerName(args);
            console.info(...args);
        },
        debug: function () {
            if (!isLogEnabled(loggerName)) {
                return;
            }

            const args = Array.prototype.slice.call(arguments);
            appendPrefixLoggerName(args);
            console.debug(...args);
        },
        warn: function () {
            if (!isLogEnabled(loggerName)) {
                return;
            }

            const args = Array.prototype.slice.call(arguments);
            appendPrefixLoggerName(args);
            console.warn(...args);
        },
        error: function () {
            if (!isLogEnabled(loggerName)) {
                return;
            }

            const args = Array.prototype.slice.call(arguments);
            appendPrefixLoggerName(args);
            console.error(...args);
        },
        isLogEnabled: name => isLogEnabled(name)
    };
};

const ENABLE_ALL_LOGGERS_VALUE = 'all';
const ALLOW_DYNAMIC_LOGGING_CHANGES_VALUE = 'no-cache';
const DISABLE_LOGGER_SYMBOL_PREFIX = '!';

const isLogEnabled = name => {
    const commaSeperatedLoggerNames = getLocalStorageValue('simworkflow.log');
    const loggerNameValues = commaSeperatedLoggerNames ?
        commaSeperatedLoggerNames.split(',') :
        [];
    const loggerValue = getLoggerValueIncludingOptionalPrefix(name,
        loggerNameValues);

    if (loggerValue) {
        return !loggerValue.includes(DISABLE_LOGGER_SYMBOL_PREFIX);
    }

    return loggerNameValues.filter(
        loggerName => loggerName === ENABLE_ALL_LOGGERS_VALUE).length > 0;
};

const getLoggerValueIncludingOptionalPrefix = (name, loggerNames) => {
    const loggerValue = loggerNames.filter(
        loggerName => loggerName === name || loggerName ===
            `${DISABLE_LOGGER_SYMBOL_PREFIX}${name}`);
    if (loggerValue.length > 0) {
        return loggerValue[0];
    } else {
        return false;
    }
};

let cachedLocalStorageValue;

const getLocalStorageValue = key => {
    if (cachedLocalStorageValue !== undefined) {
        return cachedLocalStorageValue;
    }

    try {
        const value = localStorage.getItem(key);
        if (!value?.includes(ALLOW_DYNAMIC_LOGGING_CHANGES_VALUE)) {
            cachedLocalStorageValue = value;
        }
        return value;
    } catch {
        console.error('[Logger] Failed to read from local storage the key', key);
        return null;
    }
};
